import React from "react";

import { IgTypography } from "@intelligems/ig-theme";
import { Grid } from "@mui/material";
import { MeterLogDrawer } from "@src/features/admin/components/Drawers/MeterLogDrawer/MeterLogDrawer";
import { AddOrganizationAgencyLinkDrawer } from "@src/features/admin/pages/agencies/components/Drawers/AddOrganizationAgencyLinkDrawer/AddOrganizationAgencyLinkDrawer";
import { AddCustomerGroupDrawer } from "@src/features/admin/pages/agencies/components/Drawers/CreateAgencyCustomerDrawer/AddCustomerGroupDrawer";
import { PutAgencyDrawer } from "@src/features/admin/pages/agencies/components/Drawers/PutAgencyDrawer/PutAgencyDrawer";
import { AgenciesTable } from "@src/features/admin/pages/agencies/components/Tables/AgenciesTable/AgenciesTable";
import { CreateSubscriptionDrawer } from "@src/features/admin/pages/overview/components/Drawers/SubscriptionDrawer/CreateSubscriptionDrawer";
import { ModifySubscriptionDrawer } from "@src/features/admin/pages/overview/components/Drawers/SubscriptionDrawer/ModifySubscriptionDrawer";

export const AgenciesBody = () => {
  return (
    <Grid container item direction={"column"} rowSpacing={5}>
      <Grid item>
        <IgTypography variant={"h1"} fontWeight={600}>
          Manage Agencies
        </IgTypography>
      </Grid>
      <AgenciesTable />
      <PutAgencyDrawer />
      <AddCustomerGroupDrawer />
      <AddOrganizationAgencyLinkDrawer />
      <CreateSubscriptionDrawer />
      <ModifySubscriptionDrawer />
      <MeterLogDrawer />
    </Grid>
  );
};
